<template>
    <div style="padding-top: 0.7rem;">
        <div
            style="width: 12rem; margin: .24rem auto;padding: .24rem;border-radius: 0.08rem;display: flex;column-gap: .4rem;">
            <div style="width: 1.6rem;height: 5.83rem;background: #FFF;border-radius: 8px;padding: .12rem;">
                <div style=" color:#86909c; font-size: .12rem; font-weight: 400;">
                    <span>我的课程</span>
                </div>
                <div @click="queryParams.pageNum = 1, queryParams.pageSize = 4, active = 0, getList()"
                    :style="[' font-size: .14rem; font-weight: 400;margin-top: .16rem;cursor: pointer;', active == 0 ? 'color: #c01a26;' : 'color: #333333;']">
                    <span>学习进度</span>
                </div>
                <div @click="queryParams.pageNum = 1, queryParams.type = '', queryParams.pageSize = 6, active = 1, orderList()"
                    :style="['font-size: .14rem; font-weight: 400;margin-top: .16rem;cursor: pointer;', active == 1 ? 'color: #c01a26;' : 'color: #333333;']">
                    <span>课程订单</span>
                </div>
            </div>
            <div v-if="active == 0"
                style="height: 5.83rem;border-radius: 8px;padding: .24rem;background: #FFF;flex: 1;display: flex;flex-direction: column;">
                <div style="color: #333333; font-size: .16rem; font-weight: 400;">
                    <span>学习记录</span>
                </div>
                <div style="flex: 1;margin-top: .12rem;">
                    <el-skeleton :rows="14" v-if="loading" />
                    <div v-for="item in listData" :key="item.id"
                        style="display: flex;align-items: center;column-gap: .12rem;">
                        <div style="width: 1.58rem;height: .94rem;border-radius: 8px;">
                            <img :src="item.image" style="width: 1.58rem;height: .94rem;border-radius: 8px;" alt=""
                                srcset="">
                        </div>
                        <div style="flex: 1;">
                            <div style=" color: #333333; font-size: 14px; font-weight: 400;"><span>{{ item.title }}</span>
                            </div>
                            <div style=" color: #86909c; font-size: 12px;margin-top: .08rem;">
                                <span>{{ item.content }}</span>
                            </div>
                            <div @click="$router.push('/ShadowTrainDetailPage?id=' + item.id)"
                                style=" color: #86909c; font-size: 12px; font-weight: 400;margin-top: .21rem;cursor: pointer;">
                                <span>继续观看</span>
                            </div>
                        </div>
                        <div
                            style="height: .68rem;min-width: .72rem; background: #E4E8EC;border-radius: 8px;padding: .12rem;">
                            <div style=" color: #333333; font-size: 12px; font-weight: 400;"><span>学习进度</span></div>
                            <div><span style=" color: #4bc185; font-size: 24px; font-weight: 700;">{{
                                item.progress ? item.progress.split('.')[0] : '' }}</span><span
                                    style=" color: #4bc185; font-size: 12px; font-weight: 700;">%</span></div>
                        </div>
                    </div>
                    <div v-if="listData.length == 0"
                        style="display: flex;justify-content: center;align-items: center;height: 100%;">
                        <el-empty />
                    </div>
                </div>
                <div v-if="listData.length"
                    style="padding-bottom: 20px;padding-top: 20px; display: flex;justify-content: center;align-items: center;width: 100%;">
                    <el-pagination :total="queryParams.total" background class="cccccccc"
                        :current-page="queryParams.pageNum" @current-change="paginationChange"
                        :page-size="queryParams.pageSize" />
                </div>
            </div>
            <div v-if="active == 1"
                style="height: 5.83rem;border-radius: 8px;padding: .24rem;background: #FFF;flex: 1;display: flex;flex-direction: column;">
                <el-table v-loading="loading" ref="tableRef" class="tableRef" row-key="id" :data="listData"
                    style="width: 100%;flex: 1;">
                    <el-table-column prop="courseName" label="全部课程" width="180">
                        <template #header="scope">
                            <el-select v-model="queryParams.type" placeholder="全部课程" @change="changeBtn">
                                <el-option label="全部课程" value="" />
                                <el-option label="线上课程" value="1" />
                                <el-option label="线下课程" value="2" />
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="orderSn" label="订单号" />
                    <el-table-column prop="courseType" label="详情">
                        <template #default="scope">
                            <div><span>{{ scope.row.courseType == 1 ? '线上课程' : '线下课程' }}</span></div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="price" label="价格">
                        <template #default="scope">
                            <div><span>￥{{ scope.row.coursePrice }}</span></div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="price" label="实付">
                        <template #default="scope">
                            <div><span>￥{{ scope.row.coursePrice }}</span></div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="orderState" label="发票状态">
                        <template #default="scope">
                            <div v-if="scope.row.orderState == 2">
                                <el-tag v-if="scope.row.invoiceStatus == 1" type="primary">待申请</el-tag>
                                <el-tag v-if="scope.row.invoiceStatus == 2" type="success">已申请</el-tag>
                                <el-tag v-if="scope.row.invoiceStatus == 3" type="info">开具发票完成</el-tag>
                                <el-tag v-if="scope.row.invoiceStatus == 4" type="primary">发票作废</el-tag>
                            </div>
                            <div v-else>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="orderState" label="订单状态">
                        <template #default="scope">
                            <el-tag v-if="scope.row.orderState == 1" type="primary">待支付</el-tag>
                            <el-tag v-if="scope.row.orderState == 2" type="success">已完成</el-tag>
                            <el-tag v-if="scope.row.orderState == 3" type="info">已取消</el-tag>
                            <el-tag v-if="scope.row.orderState == 4" type="primary">申请退款</el-tag>
                            <el-tag v-if="scope.row.orderState == 5" type="success">退款同意 </el-tag>
                            <el-tag v-if="scope.row.orderState == 6" type="danger">退款失败</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template #default="scope">
                            <div style="display: flex;justify-content: center;align-items: center;flex-direction: column;"
                                v-if="scope.row.orderState == 1">
                                <div @click="scope.row.courseType == 1 ? $router.push(`/orderDetail?id=${scope.row.courseId}&orData=${encodeURIComponent(JSON.stringify(scope.row))}`) : $router.push(`/signMsg?id=${scope.row.courseId}&orData=${encodeURIComponent(JSON.stringify(scope.row))}`)"
                                    style="background: #C01A26;border-radius: .04rem;width: .8rem;height: .33rem;text-align: center;line-height: .33rem; color: #ffffff; font-size: 14px;cursor: pointer;">
                                    <span>支付</span>
                                </div>
                                <div @click="cancelBtn(scope.row)"
                                    style=" color: #86909c; font-size: 14px;text-align: center;margin-top: .08rem;cursor: pointer;">
                                    <span>取消订单</span>
                                </div>
                            </div>
                            <div style="display: flex;justify-content: center;align-items: center;flex-direction: column;"
                                v-if="scope.row.orderState == 3">
                                <div @click="$router.push('/ShadowTrainDetailPage?id=' + scope.row.courseId)"
                                    style="background: #C01A26;border-radius: .04rem;width: .8rem;height: .33rem;text-align: center;line-height: .33rem; color: #ffffff; font-size: 14px;cursor: pointer;">
                                    <span>重新购买</span>
                                </div>
                            </div>
                            <div style="display: flex;justify-content: center;align-items: center;flex-direction: column;"
                                v-if="scope.row.orderState == 2">
                                <div @click="$router.push('/ShadowTrainDetailPage?id=' + scope.row.courseId)"
                                    style="background: #C01A26;border-radius: .04rem;width: .8rem;height: .33rem;text-align: center;line-height: .33rem; color: #ffffff; font-size: 14px;cursor: pointer;">
                                    <span>点击查看</span>
                                </div>
                            </div>
                            <div style="display: flex;justify-content: center;align-items: center;flex-direction: column;"
                                v-if="scope.row.orderState == 2">
                                <div v-if="scope.row.invoiceStatus == 1"
                                    @click="$router.push(`/debit?id=${scope.row.courseId}&o=${scope.row.orderSn}`)"
                                    style="background: #C01A26;border-radius: .04rem;width: .8rem;height: .33rem;text-align: center;line-height: .33rem; color: #ffffff; font-size: 14px;cursor: pointer;">
                                    <span>申请发票</span>
                                </div>
                                <div v-if="scope.row.courseType == 2" @click="applyBtn(scope.row)"
                                    style="color: #86909c; font-size: 14px;text-align: center;margin-top: .08rem;cursor: pointer;">
                                    <span>申请退款</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="background: #ffede3;border-radius: 8px;padding-left: 8px; color: #ff8741; font-size: 12px;height: .34rem;line-height: .34rem;margin-top: 20px;"
                    v-if="listData.length">
                    <span>自成功购买线下课程7日内(包含购买当日)，可前往头像-我的课程-课程订单中进行退款操作，7日后不可退款，敬请谅解！</span>
                </div>
                <div v-if="listData.length"
                    style="padding-bottom: 20px;padding-top: 20px; display: flex;justify-content: center;align-items: center;width: 100%;">
                    <el-pagination :total="queryParams.total" background class="cccccccc"
                        :current-page="queryParams.pageNum" @current-change="paginationChange"
                        :page-size="queryParams.pageSize" />
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref } from 'vue';
const urlData = new URLSearchParams(location.search);
// import moduleSEProvideMaterial from "../../components/moduleSEProvideMaterial.vue";
import { ElMessageBox, ElMessage } from "element-plus"
import { Axios } from "../../assets/js/ls_com_axios.js";
const active = ref(urlData.get('id') ? 1 : 0);
const listData = ref([]);
const loading = ref(false);
const queryParams = ref({
    pageNum: 1,
    pageSize: urlData.get('id') ? 6 : 4,
    total: 0,
    type: ""
})
const getList = () => {
    loading.value = true;
    Axios(
        "get",
        "/system/courseWeb/progress",
        {
            pageNum: queryParams.value.pageNum,
            pageSize: queryParams.value.pageSize
        },
        false,
        (res) => {
            if (res.data.code == 200) {
                listData.value = res.data.rows;
                queryParams.value.total = res.data.total;
            }
            loading.value = false;
        }, () => {
            listData.value = [];
            queryParams.value.total = 0;
            loading.value = false;
        })
}

const orderList = () => {
    loading.value = true;
    Axios(
        "get",
        "/system/courseWeb/webOrderList",
        Object.assign({
            pageNum: queryParams.value.pageNum,
            pageSize: queryParams.value.pageSize
        }, queryParams.value.type ? {
            type: queryParams.value.type,
        } : {}),
        false,
        (res) => {
            if (res.data.code == 200) {
                listData.value = res.data.rows;
                queryParams.value.total = res.data.total;
            }
            loading.value = false;
        }, () => {
            listData.value = [];
            queryParams.value.total = 0;
            loading.value = false;
        })
}
active.value == 0 ? getList() : orderList()
const paginationChange = (num) => {
    queryParams.value.pageNum = num;
    window.scrollTo({
        top: 0,
        behavior: "smooth",
    });
    active.value == 0 ? getList() : orderList()
}
const changeBtn = () => {
    queryParams.value.pageNum = 1;
    orderList()
}
const applyBtn = (item) => {
    ElMessageBox.confirm(
        '是否申请？',
        '',
        {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning',
            customClass: 'orderDetail',
            confirmButtonClass: "",
            center: true,
            closeOnClickModal: false
        }
    )
        .then(() => {
            loading.value = true;
            Axios(
                "get",
                "/system/courseWeb/refund",
                {
                    orderId: item.id
                },
                false,
                (res) => {
                    if (res.data.code == 200) {
                        orderList()
                    }
                    loading.value = false;
                }, () => {
                    loading.value = false;
                })
        }).catch(() => {

        })
}
const cancelBtn = (item) => {
    ElMessageBox.confirm(
        '是否取消订单？',
        '',
        {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning',
            customClass: 'orderDetail',
            confirmButtonClass: "",
            center: true,
            closeOnClickModal: false
        }
    )
        .then(() => {
            loading.value = true;
            Axios(
                "get",
                "/system/courseWeb/cancelOrder",
                {
                    orderId: item.id
                },
                false,
                (res) => {
                    if (res.data.code == 200) {
                        orderList()
                    }
                    loading.value = false;
                }, () => {
                    loading.value = false;
                })
        }).catch(() => {

        })

}
</script>
<style>
.cccccccc.el-pagination.is-background .btn-next.is-active,
.cccccccc.el-pagination.is-background .btn-prev.is-active,
.cccccccc.el-pagination.is-background .el-pager li.is-active {
    background-color: #C01A26 !important;
}

/* .el-pager li.is-active, */
.cccccccc .el-pager li:hover {
    color: #C01A26 !important;
}

.cccccccc .el-pager li.is-active:hover {
    color: #FFF !important;
}

.tableRef .el-select__wrapper {
    box-shadow: none
}
</style>
<style lang="less">
.orderDetail .el-message-box__title {
    font-size: 60px !important;
    padding-left: 25px !important;
}

.orderDetail {
    border-radius: 12px !important;
}

.orderDetail .el-message-box__btns {
    button {
        width: 88px !important;
        line-height: 32px !important;
        text-align: center;
        line-height: 32px;
    }
}

.orderDetail .el-button--primary {
    background: #C01A26;
    border: 1px solid #C01A26;
}

.orderDetail .el-button:focus-visible {
    outline: 2px solid #C01A26;
}

.orderDetail .el-message-box__headerbtn:focus .el-message-box__close,
.el-message-box__headerbtn:hover .el-message-box__close {
    color: #C01A26;
}
</style>